"use client";
import { ServiceOtherType } from "@/types/global";
import Image from "next/image";

interface Props {
    data: ServiceOtherType;
}

const ServiceAreaCard = ({ data }: Props) => {
    return (
        <>
            <div
                className="col-md-6 col-xl-4 " //col-xxl-3
            >
                <div className="desilo-service-box6 bg-color-white move-anim h-100">
                    <div className="service-icon">
                        <Image
                            height={52}
                            width={52}
                            src={data.icon}
                            alt="service-icon"
                        />
                    </div>
                    <div className="service-content">
                        <h3>{data.title}</h3>
                        <p>{data.description}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServiceAreaCard;
